import { Injectable }          from '@angular/core';
import * as firebase from 'firebase';
import 'rxjs/add/operator/take';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';

@Injectable()
export class MessagingService {

  messaging = firebase.messaging();
  currentMessage = new BehaviorSubject(null);

  constructor(private db: AngularFireDatabase, private afAuth: AngularFireAuth) { }

  updateToken(token) {
    this.afAuth.authState.take(1).subscribe(user => {
      if (!user) return;

      const data = { [user.uid]: token }
      if(localStorage.getItem("courierapp_user_id") == user.uid)
      {
        this.db.object('fcmTokens/').update(data);
      }
    });
  }

  getPermission() {
      this.messaging.requestPermission()
      .then(() => {
        //console.log('Notification permission granted.');
        return this.messaging.getToken()
      })
      .then(token => {
        //console.log(token)
        this.updateToken(token)
      })
      .catch((err) => {
        //console.log('Unable to get permission to notify.', err);
      });
    }

    receiveMessage() {
       this.messaging.onMessage((payload) => {
        //console.log("Message received. ", payload);
        this.currentMessage.next(payload)
      });

    }
}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/messagingservice.ts